export const FIELD_EXPENSE_CATEGORIES = {
  insumos: 'Insumos',
  maquinas: 'Máquinas e combustível',
  mao_de_obra: 'Mão de obra',
  servicos: 'Serviços',
  outros: 'Outros',
};

export function collectRealizedFieldCosts({ expenses = [], executions = [], events = [] } = {}) {
  const entries = [];
  const append = (source, record, value, date) => {
    if (value == null || !Number.isFinite(Number(value)) || Number(value) < 0) return;
    entries.push({
      id: `${source}:${record.id}`,
      orderId: record.ordem_id || null,
      propertyId: record.propriedade_id,
      plotId: record.talhao_id,
      value: Math.round(Number(value) * 100) / 100,
      date,
      source,
      description: record.descricao || '',
    });
  };
  expenses.filter(expense => !expense.estornado_em && (expense.natureza || 'realizado') === 'realizado')
    .forEach(expense => append('despesa', expense, expense.valor, expense.data_despesa));
  executions.filter(execution => execution.status === 'finalizada')
    .forEach(execution => append('execucao', execution, execution.custo_real, execution.inicio_em));
  events.forEach(event => append('evento', event, event.custo_total, event.data_evento));
  return entries;
}

export function sumFieldCosts(entries) {
  return entries.reduce((total, entry) => total + Math.round(entry.value * 100), 0) / 100;
}

export function summarizeTaskCosts(task, expenses = []) {
  const orderId = task.recordId || (!task.isLegacyEvent ? task.id : null);
  const linkedExpenses = orderId
    ? expenses.filter(expense => String(expense.ordem_id) === String(orderId))
    : [];
  const executions = task.costExecutions || (task.execution && !task.isLegacyEvent ? [{
    status: 'finalizada',
    custo_real: task.execution.cost == null ? null : Number(String(task.execution.cost).replace(/\./g, '').replace(',', '.')),
  }] : []);
  const legacyEntries = collectRealizedFieldCosts({
    executions,
    events: task.legacyCost == null ? [] : [{ id: task.id, custo_total: task.legacyCost }],
  });
  const realizedEntries = collectRealizedFieldCosts({ expenses: linkedExpenses });
  return {
    expenses: linkedExpenses,
    legacyTotal: sumFieldCosts(legacyEntries),
    realizedTotal: legacyEntries.length || realizedEntries.length
      ? sumFieldCosts([...legacyEntries, ...realizedEntries]) : null,
    plannedTotal: task.plannedCost == null ? null : Number(task.plannedCost),
  };
}

export function formatFieldCost(value) {
  return value == null ? 'Não informado' : Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}